import React, { useState, useEffect, useRef } from 'react';

import { formatTime } from '@utils/date';
import { useIntl } from 'react-intl';

interface DowntimeTimerProps {
  initialTime: number;
  resendOtp: () => void;
}

const DowntimeTimer: React.FC<DowntimeTimerProps> = ({
  initialTime,
  resendOtp
}) => {
  const intl = useIntl();
  const [seconds, setSeconds] = useState<number>(initialTime);
  const [timerExpired, setTimerExpired] = useState<boolean>(false);
  const intervalIdRef = useRef<NodeJS.Timeout | null>(null);

  const resetTimer = () => {
    intervalIdRef.current = setInterval(() => {
      setSeconds((prevSeconds) => prevSeconds - 1);
    }, 1000);
  };

  const handleResendOtp = () => {
    resendOtp();
    setTimerExpired(false);
    setSeconds(initialTime);
    resetTimer();
  };

  useEffect(() => {
    resetTimer();
    // Cleanup interval when the component unmounts
    return () => {
      clearInterval(intervalIdRef.current!);
    };
  }, []);

  useEffect(() => {
    if (seconds === 0) {
      setTimerExpired(true);
      clearInterval(intervalIdRef.current!);
    }
  }, [seconds]);

  return (
    <div className="flex text-xs font-normal">
      <span className="text-primary">
        {' '}
        {intl.formatMessage({
          id: 'verification.havingTrouble'
        })}
      </span>{' '}
      {` `}
      {timerExpired ? (
        <div
          className="ml-1 cursor-pointer text-primary"
          role="presentation"
          onClick={handleResendOtp}
        >
          {intl.formatMessage({
            id: 'verification.resendOtp'
          })}
        </div>
      ) : (
        <div className="ml-1">
          {intl.formatMessage({
            id: 'verification.requestANewCodeIn'
          })}
          <span className="text-primary">{formatTime(seconds)}</span>
        </div>
      )}
    </div>
  );
};

export default DowntimeTimer;
